import { Component, ElementRef, ViewChild } from '@angular/core';
// Module
import { lastValueFrom } from 'rxjs';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { LazyLoadEvent, MessageService } from 'primeng/api';
// Service
import { QualityDocumentService } from '../../../../service/document-quality.service';
// Model
import { OrderDetailModel } from '@cv-invision/cv.invision-intelligence.ux';
import { HistoricalOrderDetailResponse, HistoricalOrderItem } from '../../../model/historical-order-detail.model';

@Component({
	selector: 'cv-historical-order-dialog',
	templateUrl: 'historical-order-dialog.component.html',
	styleUrls: ['historical-order-dialog.component.scss'],
	providers: [MessageService]
})
export class HistoricalOrderDialogComponent {
	orderDetail!: OrderDetailModel;
	public historicalOrderDetails!: HistoricalOrderDetailResponse;
	@ViewChild('tableHost', { static: true }) tableHost!: ElementRef<HTMLElement>;

	historyRows: HistoricalOrderItem[] = [];
	loading = true;

	// paginator settings
	rows = 20;
	totalRecords = 0;

	constructor(
		private qualityService: QualityDocumentService,
		public dialogConfig: DynamicDialogConfig,
		private messagesService: MessageService
	) {
		this.orderDetail = this.dialogConfig.data?.orderDetail;
	}

	/**
	 * Loads the historical details of an order using pagination from Primeng
	 * @param {LazyLoadEvent} event
	 * @returns {Promise<void>}
	 */
	async loadOrderHistoricalDetails(event?: LazyLoadEvent): Promise<void> {
		if (!this.orderDetail?.id) {
			this.loading = false;
			return;
		}

		const offset = event?.first ?? 0;
		const limit = event?.rows ?? this.rows;

		this.loading = true;

		try {
			const res = await lastValueFrom(
				this.qualityService.getOrderHistoricalDetails(this.orderDetail.id, offset, limit)
			);

			this.historicalOrderDetails = res;

			this.historyRows = res.statusHistoryResult?.data ?? [];
			this.totalRecords = res.statusHistoryResult?.totalCount ?? 0;
			this.rows = limit;

			setTimeout(() => this.scrollTableToTop());
		} catch (err) {
			const errorObject = err as any;
			this.messagesService.add({
				severity: 'error',
				summary: 'Not Found',
				detail: errorObject?.error?.message ?? ''
			});
			console.error(err);
			this.historyRows = [];
			this.totalRecords = 0;
		} finally {
			this.loading = false;
		}
	}

	/**
	 * Scrolls the data table wrapper to the top.
	 * @returns
	 */
	private scrollTableToTop(): void {
		const wrapper = this.tableHost.nativeElement.querySelector('.p-datatable-wrapper') as HTMLElement | null;
		if (wrapper) {
			wrapper.scrollTop = 0;
			return;
		}

		const dialogContent = this.tableHost.nativeElement.closest('.p-dialog-content') as HTMLElement | null;
		if (dialogContent) dialogContent.scrollTop = 0;
	}
}
